import ReactDOM from 'react-dom';

import App from './App';
import { initAutoTrackBeacon } from './datahub';

import './index.css';

initAutoTrackBeacon();

const renderApp = () => ReactDOM.render(<App />, document.getElementById('root'));

renderApp();
